/* eslint-disable no-param-reassign */
export default {
  install(Vue) {
    Vue.prototype.$getValidationState = ({ dirty, validated, valid = null }) => (dirty || validated ? valid : null)
  },
}
